export const InvoiceStatus = {
    DRAFT: 0,
    PENDING: 5,
    RETURNED: 15,
    REJECTED: 20,
    APPROVED: 30
};
